import { Reveal } from "../components/Reveal";
import { Seo } from "../components/Seo";
import { menu, site } from "../data/site";
import { useT, menuText } from "../data/i18n";

export const Carta = () => {
  const { t, lang } = useT();
  const localized = menuText[lang] || menuText.es;
  let idx = 0;

  return (
    <>
      <Seo title="Carta | Tagines, cuscús, harira y té moruno — Yasmina Puigcerdà" description="Carta de cocina árabe y marroquí halal en Puigcerdà: tagines de cordero y pollo, cuscús real, harira, briwats y postres marroquíes." path="/carta" />
      <section className="menu-hero">
        <div className="container">
          <Reveal><div className="label">{t("carta_kicker")}</div></Reveal>
          <Reveal delay={1}>
            <h1>{t("carta_title")}</h1>
          </Reveal>
          <Reveal delay={2}>
            <p>{t("carta_lead")}</p>
          </Reveal>
          <Reveal delay={3}>
            <div className="menu-note">{t("carta_note")}</div>
          </Reveal>
        </div>
      </section>

      <div className="container">
        {menu.map((cat, ci) => {
          const catName = localized.cats[ci] || cat.cat;
          return (
            <div key={cat.cat} className="menu-cat" data-testid={`menu-cat-${ci}`}>
              <Reveal>
                <h2>{catName}</h2>
              </Reveal>
              {cat.items.map((it, i) => {
                const [name, desc] = localized.items[idx++] || [it.name, it.desc];
                return (
                  <Reveal key={it.name} delay={Math.min(4, i + 1)}>
                    <article className="menu-item" data-testid={`menu-item-${ci}-${i}`}>
                      <div
                        className="img"
                        style={{ backgroundImage: `url(${it.img})` }}
                        role="img"
                        aria-label={name}
                      />
                      <div>
                        <h3>{name}</h3>
                        <p>{desc}</p>
                      </div>
                    </article>
                  </Reveal>
                );
              })}
            </div>
          );
        })}
      </div>

      <section style={{ textAlign: "center", padding: "80px 0 120px" }}>
        <Reveal>
          <div className="label" style={{ marginBottom: 14 }}>{t("carta_cta_kicker")}</div>
        </Reveal>
        <Reveal delay={1}>
          <h2 style={{ maxWidth: 640, margin: "0 auto 26px" }}>{t("carta_cta_title")}</h2>
        </Reveal>
        <Reveal delay={2}>
          <a href={site.mapLink} target="_blank" rel="noreferrer" className="btn primary" data-testid="carta-cta-wa">
            {t("btn_map")}
          </a>
        </Reveal>
      </section>
    </>
  );
};
